export enum CourierHaulierSwitchPromptPages {
  CONTAINER_ELIGIBILITY_RULES,
  PALLET_DELIVERY_SETTINGS,
}
